export default "__VITE_ASSET__gCbUG3R___"